document.addEventListener('DOMContentLoaded', function() {
    const $toggleElements = document.querySelectorAll('[data-ec-toggle]');

    function toggleElement($targetElement) {
        $targetElement.classList.toggle('show');
    }

    function dismissElement($targetElement) {
        $targetElement.remove();
    }

    function toggleOffcanvas($targetElement) {
        const backdropClass = 'offcanvas-backdrop';

        toggleElement($targetElement);

        if($targetElement.classList.contains('show')) {
            // Create backdrop if not already present
            let $offcanvasBackdrop = $targetElement.nextElementSibling;
            if (!$offcanvasBackdrop || !$offcanvasBackdrop.classList.contains(backdropClass)) {
                $offcanvasBackdrop = document.createElement('div');
                $offcanvasBackdrop.classList.add(backdropClass);

                $offcanvasBackdrop.addEventListener('click', function (e) {
                    e.preventDefault();
                    $targetElement.classList.remove('show');
                    $targetElement.classList.add('transitioning');
                    $offcanvasBackdrop.remove();
                });

                $targetElement.insertAdjacentElement('afterend', $offcanvasBackdrop);
            }
        }
        else {
            const $offcanvasBackdrop = $targetElement.nextElementSibling;
            if ($offcanvasBackdrop && $offcanvasBackdrop.classList.contains(backdropClass)) {
                $offcanvasBackdrop.remove();
            }
        }
    }

    function toggleModal($targetElement) {
        const $body = document.body;
        toggleElement($targetElement);
        const $dialog = $targetElement.querySelector('.modal-dialog');

        $dialog.addEventListener('click', function(e) {
            e.stopPropagation();
        });

        if($targetElement.classList.contains('show')) {
            let $modalBackdrop = document.createElement('div');
            $modalBackdrop.style.display = 'block';
            $modalBackdrop.setAttribute('aria-modal', true);
            $modalBackdrop.setAttribute('role', 'dialog');
            $modalBackdrop.scrollTop = 0;

            $body.append($modalBackdrop);

            $modalBackdrop.classList.add('modal-backdrop');
            $modalBackdrop.classList.add('show');

            $targetElement.addEventListener('click', function(e) {
                e.preventDefault();
                $targetElement.classList.remove('show');
                $targetElement.classList.add('transitioning');
                $modalBackdrop.remove();
            });
        }
        else {
            const $modalBackdrop = $body.querySelector('.modal-backdrop');
            if ($modalBackdrop) {
                $modalBackdrop.remove();
            }
        }
    }

    $toggleElements.forEach($toggleButton => {
        $toggleButton.addEventListener('click', function(e) {
            e.preventDefault();

            const toggleType = $toggleButton.getAttribute('data-ec-toggle');
            const targetSelector = $toggleButton.getAttribute('data-ec-target');
            const $targetElement = document.querySelector(targetSelector);

            if(toggleType == 'offcanvas' && $targetElement) {
                toggleOffcanvas($targetElement);
            }
            else if(toggleType == 'show' && $targetElement) {
                toggleElement($targetElement);
            }
            else if(toggleType == 'modal' && $targetElement) {
                toggleModal($targetElement);
            }
        });
    });

    const $closeButtons = document.querySelectorAll('[data-ec-dismiss]');

    $closeButtons.forEach($closeButton => {
        $closeButton.addEventListener('click', function(e) {
            e.preventDefault();

            const dismissType = $closeButton.getAttribute('data-ec-dismiss');

            if(dismissType === 'offcanvas') {
                const $targetElement = $closeButton.closest('.offcanvas');

                if($targetElement) {
                    toggleOffcanvas($targetElement);
                }
            }
            if(dismissType === 'show') {
                const $targetElement = $closeButton.closest('.slidein');

                if($targetElement) {
                    toggleElement($targetElement);
                }
            }
            if(dismissType === 'modal') {
                const $targetElement = $closeButton.closest('.modal');

                if($targetElement) {
                    toggleModal($targetElement);
                }
            }
            if(dismissType === 'alert') {
                const $targetElement = $closeButton.closest('.alert');

                if($targetElement) {
                    dismissElement($targetElement);
                }
            }
        });
    });

    const $bootstrapDismissButtons = document.querySelectorAll('[data-bs-dismiss="alert"]');

    $bootstrapDismissButtons.forEach($closeButton => {
        $closeButton.addEventListener('click', function(e) {
            e.preventDefault();

            const $targetElement = $closeButton.closest('.alert');

            if($targetElement) {
                dismissElement($targetElement);
            }
        });
    });
});
